import React, {useEffect, useRef, useState} from 'react';

import {NavigationTabsModuleProps} from "../models/navigation-tabs-module.props";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import classNames from "classnames";
import styles from "../styles/navigation-tabs.module.scss";
import {NavigationTabsModuleController} from "../navigation-tabs-module.controller";
import {NavigationTabsModuleButton} from "./navigation-tabs-module.button";
import type {NavigationTabsModuleTabModel} from "../models/tabs/navigation-tabs-module.tab-model";
import {NavigationTabsModuleArrowBackward} from "./navigation-tabs-module.arrow.backward";
import {NavigationTabsModuleArrowForward} from "./navigation-tabs-module.arrow.forward";
import {NavigationTabsModuleComposer} from "./navigation-tabs-module.composer";
import {ShadowWrapper} from "../../../core/components/new-shadow-wrapper/shadow-wrapper";

export class NavigationTabsModuleComponentProps extends NavigationTabsModuleProps {
}

export const NavigationTabsModuleComponent = NavigationTabsModuleComposer(({
                                                                             controller,
                                                                             onTabClick,
                                                                             currentIndex,
                                                                             entity,
                                                                             supportArrows,
                                                                             className,
                                                                             tabClassName
                                                                           }: NavigationTabsModuleComponentProps) => {
  const {state, device} = controller;
  const {isSmallView, isRtl} = device;
  const {entityContext} = state;
  const ref = useRef();
  const [isScrollable, setIsScrollable] = useState(false);

  useEffect(() => {
    setIsScrollable(supportArrows && ref.current?.clientWidth < ref.current?.scrollWidth)
  }, [entity?.id, currentIndex])

  const arrowProps = {
    controller,
    onClick: (direction) => onTabClick(null, direction)
  }

  const backwardArrowProps = {
    shouldRenderArrow: !entityContext?.isFirstTabIndex && isScrollable && !isSmallView,
    isScrollable,
    ...arrowProps
  }

  const forwardArrowProps = {
    shouldRenderArrow: !entityContext?.isLastTabIndex && isScrollable && !isSmallView,
    isScrollable,
    ...arrowProps
  }


  const shadowWrapperProps = {
    className: classNames(className, styles.tabs),
    shouldRenderShadows: isSmallView,
    shadowWidth: 12,
    isRtl
  }

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView}, {[styles.scrollable]: isScrollable})}>
      <NavigationTabsModuleArrowBackward {...backwardArrowProps}/>
      <ShadowWrapper {...shadowWrapperProps}>
        <div className={classNames(className, styles.tabs)} ref={ref}>
          {
            entityContext?.tabs?.map((tab: NavigationTabsModuleTabModel) =>
              <NavigationTabsModuleButton
                ref={ref}
                tab={tab}
                key={tab.tabName}
                onClick={onTabClick}
                isScrollable={isScrollable}
                className={tabClassName}
                useRouteProps={entityContext.useRouteProps}
              />)
          }
        </div>
      </ShadowWrapper>
      <NavigationTabsModuleArrowForward {...forwardArrowProps}/>
    </div>
  );
});

const settings: ComposeSettings = {
  component: NavigationTabsModuleComponent,

  observe: true,
  createModule: true,
  propsType: NavigationTabsModuleComponentProps,
  controllerType: NavigationTabsModuleController
};

export default Compose(settings);
